import { getBroadcastAuditReportData } from '@common/services/submissionService';
import useWaitingMutation from '@common/hooks/useWaitingMutation';
import { convertObjectToQueryString } from '@common/filterFormHelpers';
import { usePleaseWaitOverlay } from '@common/components/PleaseWaitOverlay/usePleaseWaitOverlay';

interface IMutationData {
  from?: string | null;
  to?: string | null;
}

interface IMutationProps {
  successCallback: (response: unknown) => void;
  errorCallback: () => void;
}

export const useGetBroadcastAuditReportData = ({ successCallback, errorCallback }: IMutationProps) => {
  const { handleShowOverlay, handleHideOverlay } = usePleaseWaitOverlay();

  const handleSuccess = (response: unknown) => {
    handleHideOverlay();
    successCallback(response);
  };

  const handleError = () => {
    handleHideOverlay();
    errorCallback();
  };

  const { mutate: generateBroadcastAuditReport, isLoading: isBroadcastAuditReportGenerating } = useWaitingMutation(
    (data: IMutationData) => {
      const queryString = convertObjectToQueryString(data);
      return getBroadcastAuditReportData(queryString);
    },
    { onMutate: handleShowOverlay, onSuccess: handleSuccess, onError: handleError },
  );

  return {
    generateBroadcastAuditReport,
    isBroadcastAuditReportGenerating,
  };
};
